import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "../helper/APIClient";

const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 min

const AutoLogoutTimer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const timerRef = useRef<number | null>(null);

    useEffect(() => {
  if (location.pathname === "/login" || location.pathname === "/signup" || location.pathname === "/partner-application") {
            return;
        }

        const performLogout = async () => {
            try {
                await signOut();
            } catch (e) {
                console.error("Logout failed:", e);
            } finally {
                localStorage.removeItem("lastActivity");
                navigate("/login", { replace: true });
            }
        };

        const resetTimer = () => {
            localStorage.setItem("lastActivity", Date.now().toString());

            if (timerRef.current) clearTimeout(timerRef.current);

            timerRef.current = window.setTimeout(() => {
                performLogout();
            }, INACTIVITY_LIMIT);
        };

        const lastActivity = Number(localStorage.getItem("lastActivity") || Date.now());
        const timeLeft = INACTIVITY_LIMIT - (Date.now() - lastActivity);

        if (timeLeft <= 0) {
            performLogout();
            return;
        }

        timerRef.current = window.setTimeout(performLogout, timeLeft);

        const events = ["mousemove", "keydown", "click", "scroll"];

        events.forEach(e => window.addEventListener(e, resetTimer));

        return () => {
            events.forEach(e => window.removeEventListener(e, resetTimer));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [location.pathname, navigate]);

    return null;
};

export default AutoLogoutTimer;
